import { useState } from "react";
import { Helmet } from "react-helmet";
import { getTheme } from "./components/Theme";

import Navbar     from "./components/Navbar";
import Hero       from "./components/Hero";
import Projects   from "./components/Projects";
import Skills     from "./components/Skills";
import About      from "./components/About";
import ContactCTA from "./components/ContactCTA";
import Footer     from "./components/Footer";

export default function App() {
  // ── WHITE is default ────────────────────────────────────────────────────────
  const [darkMode, setDarkMode] = useState(false);
  const theme = getTheme(darkMode);

  return (
    <div style={{ background: theme.bg, color: theme.fg, minHeight: "100vh", transition: "background 0.4s, color 0.4s" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Mono:ital,wght@0,300;0,400;0,500;1,300&family=Bebas+Neue&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'DM Mono', 'Courier New', monospace; }
        ::selection { background: #84cc16; color: #000; }
        a { text-decoration: none; color: inherit; }
        button { font-family: 'DM Mono', 'Courier New', monospace; }

        /* Responsive tweaks */
        @media (max-width: 768px) {
          section { padding-left: 20px !important; padding-right: 20px !important; }
          nav     { padding-left: 20px !important; padding-right: 20px !important; }
          footer  { padding-left: 20px !important; padding-right: 20px !important; }
        }
        @media (max-width: 640px) {
          /* Stack two-col grids on mobile */
          .two-col { grid-template-columns: 1fr !important; gap: 40px !important; }
          /* Role cards */
          .role-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>

      <Helmet>
        <html lang="en" />
        <title>David Olarinde – Frontend Developer · UI/UX · Product Manager</title>
        <meta
          name="description"
          content="Portfolio of David Olarinde — Frontend Developer, UI/UX Designer & certified Product Manager. Building fast, beautiful digital products with React, Tailwind, and Web3."
        />
        <meta name="keywords" content="David Olarinde, React Developer, Tailwind CSS, Frontend Developer, UI UX Designer, Product Manager, JavaScript, Web Portfolio" />
        <meta name="author" content="David Olarinde" />
        <link rel="canonical" href="https://olarindedavid.vercel.app/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="David Olarinde – Frontend Dev · UI/UX · Product Manager" />
        <meta property="og:description" content="Building fast, beautiful digital products. React, Tailwind, Web3." />
        <meta property="og:url" content="https://olarindedavid.vercel.app/" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@davidaintnokid" />
        <meta name="robots" content="index, follow" />
        <meta name="theme-color" content="#fafaf8" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "Person",
            "name": "David Olarinde",
            "url": "https://olarindedavid.vercel.app",
            "jobTitle": "Frontend Developer",
            "description": "Frontend Developer, UI/UX Designer, and certified Product Manager specializing in React, Tailwind CSS, and modern web technologies.",
            "sameAs": [
              "https://github.com/DaveInnovator",
              "https://x.com/davidaintnokid"
            ]
          }
        `}</script>
      </Helmet>

      <Navbar     theme={theme} onToggleTheme={() => setDarkMode(!darkMode)} />
      <Hero       theme={theme} />
      <Projects   theme={theme} />
      <Skills     theme={theme} />
      <About      theme={theme} />
      <ContactCTA theme={theme} />
      <Footer     theme={theme} />
    </div>
  );
}